export const TICKET_STATUSES = [
  { id: "open", name: "Open" },
  { id: "in_progress", name: "In progress" },
  { id: "resolved", name: "Resolved" },
  { id: "closed", name: "Closed" },
];

/**
 * Set by the admin during triage and carried onto the task the ticket becomes,
 * so the developer sees what kind of work it is without reading the thread.
 */
export const TICKET_TAGS = [
  { id: "bug", name: "Bug" },
  { id: "fix", name: "Fix" },
  { id: "feature_change", name: "Feature change" },
  { id: "requirement_change", name: "Requirement change" },
  { id: "question", name: "Question" },
];

export const TICKET_PRIORITIES = [
  { id: "low", name: "Low" },
  { id: "normal", name: "Normal" },
  { id: "high", name: "High" },
  { id: "urgent", name: "Urgent" },
];

export const nameOf = (
  choices: { id: string; name: string }[],
  id: string | null | undefined,
) => (id ? (choices.find((c) => c.id === id)?.name ?? id) : "");
